import initCharterFilter from '@PROJECT_ROOT/assets/desktop/js/charter/searchFilter';

window.initCharterFilter = initCharterFilter;
